import React, {useState} from "react";
import {Button, CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";


// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {applicativeProvider} from "../../../providers/applicativeProvider";
import Select from "react-select";
import {
    getFirstDayOfMonth,
    getFirstDayOfYear,
    getLastDayOfMonth, getLastDayOfYear,
    monthSelectOptions,
    yearSelectOptions
} from "../../../util/DateTools";
import Moment from "moment/moment";



const DailyTranslationCountFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;


    const date = new Date()
    const [searchBy, setSearchBy] = useState('RANGE'); // YEAR, MONTH, RANGE
    const [applicative, setApplicative] = useState( null);
    const [yearOption, setYearOption] = useState(null);
    const [monthOption, setMonthOption] = useState(null);
    const [startDate, setStartDate] = useState( Moment(getFirstDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD') );
    const [endDate, setEndDate] = useState( Moment(getLastDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD') );


    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            startDate : Moment(getFirstDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD'),
            endDate : Moment(getLastDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD'),
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            item : {
                startDate : Moment(startDate).format('YYYY-MM-DD'),
                endDate : Moment(endDate).format('YYYY-MM-DD')
            }
        };

        if (applicative != null)
            dataFilter.item.applicative = applicative;

        props.setFilter(path, dataFilter);
    };



    const onYearChange = year => {
        const itemOption = yearSelectOptions.find( it => it.value === year );
        const start = getFirstDayOfYear( year );
        const end = getLastDayOfYear( year );

        setYearOption(itemOption);
        setStartDate( start );
        setEndDate( end );
    }

    const onMonthChange = month => {
        const itemOption = monthSelectOptions.find( it => it.value === month );
        const selectedMonth = parseInt( month ) - 1;
        const start = getFirstDayOfMonth( date.getFullYear(), selectedMonth );
        const end = getLastDayOfMonth( date.getFullYear(), selectedMonth );

        setMonthOption( itemOption );
        setStartDate( start );
        setEndDate( end );
    }








    const changeSearchType = (_searchBy) => {
        setSearchBy(_searchBy)
        setMonthOption(null);
        setYearOption(null);
        onMonthChange(monthOption.value);
    }




    const cleanFields = () => {
        setSearchBy('RANGE')
        setMonthOption(null);
        setYearOption(null);
        reset({
            startDate : Moment(getFirstDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD'),
            endDate : Moment(getLastDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD'),
        });
    }




    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="2" style={{marginTop: '3.76rem'}}>
                    <FormGroup>
                        <SelectGeneric
                            title={ 'Aplicación' }
                            initialValue={ applicative }
                            setExternalValue = { value => setApplicative( value ) }
                            isDisabled = { false }
                            provider = { applicativeProvider }
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <Row>
                        <Col md="4">
                            <Button onClick={_ => changeSearchType('RANGE')} >Por fecha:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="6" >
                            <Label>Desde</Label>
                            <Input type="date"
                                   name="from"
                                   value={startDate}
                                   disabled={ !(searchBy === 'RANGE') }
                                   onChange={e => setStartDate(e.target.value)}
                                   innerRef={register}
                            />
                        </Col>
                        <Col md="6">
                            <Label>Hasta</Label>
                            <Input type="date"
                                   name="to"
                                   value={endDate}
                                   disabled={ !(searchBy === 'RANGE') }
                                   onChange={e => setEndDate(e.target.value)}
                                   innerRef={register}
                            />
                        </Col>
                    </Row>
                </Col>


                <Col md="3">
                    <Row>
                        <Col>
                            <Button onClick={_ => changeSearchType('MONTH')} >Por mes:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="12">
                            <Label>Mes</Label>
                            <Select
                                value = { monthOption }
                                options = { monthSelectOptions }
                                isClearable = { true }
                                isDisabled = { !(searchBy === 'MONTH') }
                                onChange = { val => onMonthChange(val?.value) }
                            />
                        </Col>
                    </Row>
                </Col>



                <Col md="3">
                    <Row>
                        <Col>
                            <Button onClick={_ => changeSearchType('YEAR')} >Por año:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="12">
                            <Label>Año</Label>
                            <Select
                                value = { yearOption }
                                options = {yearSelectOptions}
                                isClearable = { true }
                                isDisabled = { !(searchBy === 'YEAR') }
                                onChange = { val => onYearChange(val?.value) }
                            />
                        </Col>
                    </Row>
                </Col>





                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={cleanFields}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(DailyTranslationCountFilters)